import Head from 'next/head'
import React, { useEffect, useState } from 'react'

import useTopicWithProgression from '../hooks/useTopicWithProgression'
import Card from '../partials/Topic/TopicCard'
import TopicPlaceholder from '../partials/Topic/TopicPlaceholder'
import GenericList from '../components/GenericList'
import { EmptyState, EmptyStateAction } from 'components/EmptyState'
import TabbedNav from '../components/TabbedNav'
import useTopicSurveyBanner from '../hooks/useTopicSurveyBanner'

import type { ListState } from '../components/GenericList'

const TopicListRevamp = () => {
  const [dataState, setDataState] = useState<ListState>('idle')
  const { topicWithProgress, fetchStatus, progressData } =
    useTopicWithProgression()
  const topicSurveyBanner = useTopicSurveyBanner()

  useEffect(() => {
    switch (fetchStatus) {
      case 'success':
        setDataState('success')
        break
      case 'fetching_topics':
      case 'fetching_progress':
        setDataState('loading')
        break
      case 'error_fetching_progress':
      case 'error_fetching_topics':
        setDataState('error')
        break
    }
  }, [fetchStatus])

  return (
    <>
      <Head>
        <title>Pelatihan Mandiri | Daftar Topik</title>
      </Head>
      <TabbedNav activeMenu="topik" />
      <div
        className="bg-gray-10"
        style={{
          minHeight: 'calc(100vh - 3.5rem)',
        }}
      >
        <div className="px-3 pb-5">
          <div className="pt-12">
            {topicSurveyBanner(progressData?.data, { className: 'mb-2' })}
            <GenericList
              data={topicWithProgress}
              dataState={dataState}
              listKey={({ id }) => id}
              errorComponent={
                <EmptyState
                  title="Data gagal dimuat"
                  description="Ada kesalahan pada sistem. Silakan coba beberapa saat lagi."
                >
                  <EmptyStateAction onClick={() => window.location.reload()}>
                    Muat Ulang
                  </EmptyStateAction>
                </EmptyState>
              }
              emptyComponent={
                <EmptyState
                  title="Konten belum tersedia"
                  description="Belum ada topik yang dapat dipelajari saat ini; silakan coba lagi nanti."
                />
              }
              loadingComponent={<TopicPlaceholder amount={4} />}
              renderItem={({
                id,
                name,
                totalModule,
                description,
                headerImage,
                badge,
                certifiable,
              }) => (
                <>
                  <Card
                    topicId={id}
                    isFetchingProgress={dataState !== 'success'}
                    name={name}
                    certifiable={certifiable}
                    totalModule={totalModule}
                    description={description}
                    href={`/pelatihan-mandiri/topik/${id}`}
                    image={headerImage}
                    badge={badge}
                  />
                </>
              )}
              itemClassName="mb-2"
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default TopicListRevamp
